/**
 * Brand Plane Bridge — L1/L2 allowlists · forbidden Business tokens (AP-BRAND-04)
 * @see docs/inflomatrix-constitution/ui-architecture/BRAND_PLANE_BRIDGE.md
 */

/** Ant Design seed tokens permitted at L1 Identity injection */
export const BRAND_INJECTION_L1_ANTD_TOKENS = [
  'colorPrimary',
  'colorLink',
  'colorLinkHover',
  'colorLinkActive',
  'colorTextLightSolid',
] as const;

/** Additional Ant Design seed tokens permitted at L2 Accent++ (opt-in) */
export const BRAND_INJECTION_L2_ANTD_TOKENS = [
  ...BRAND_INJECTION_L1_ANTD_TOKENS,
  'fontFamily',
  'borderRadius',
  'borderRadiusLG',
] as const;

export type BrandInjectionL1Token = (typeof BRAND_INJECTION_L1_ANTD_TOKENS)[number];
export type BrandInjectionL2Token = (typeof BRAND_INJECTION_L2_ANTD_TOKENS)[number];

/** CSS / ThemeConfig keys that must never flow from Site theme into Business (L3 forbidden) */
export const BRAND_INJECTION_FORBIDDEN_BUSINESS_TOKENS = [
  'colorBgBase',
  'colorBgContainer',
  'colorBgLayout',
  'colorBgElevated',
  'colorText',
  'colorTextSecondary',
  'colorTextTertiary',
  'colorTextQuaternary',
  'colorTextDescription',
  'controlHeight',
  'controlHeightSM',
  'controlHeightLG',
  'fontSize',
  'fontSizeSM',
  'lineHeight',
  'motionDurationMid',
  '--layout-bg',
  '--surface-glass-03',
  '--surface-glass-04',
  '--surface-glass-06',
  '--surface-subtle',
  '--surface-canvas',
  '--font-display',
  '--site-density-scale',
  '--section-gap-sm',
  '--section-gap-md',
  '--section-gap-lg',
] as const;

export type BrandInjectionForbiddenToken =
  (typeof BRAND_INJECTION_FORBIDDEN_BUSINESS_TOKENS)[number];

export function isForbiddenBusinessBrandToken(key: string): boolean {
  return (BRAND_INJECTION_FORBIDDEN_BUSINESS_TOKENS as readonly string[]).includes(key);
}

export function allowedAntdTokensForLevel(level: 'L1' | 'L2'): readonly string[] {
  return level === 'L2' ? BRAND_INJECTION_L2_ANTD_TOKENS : BRAND_INJECTION_L1_ANTD_TOKENS;
}
